module.exports = __webpack_public_path__ + "img/RestCardBackground.ff72e89c.jpg";